import React, {useEffect, useState} from "react";
import "./EventTable.css";
import axios from "axios";

function EventTable() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios.get('http://localhost:8888/events/all', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then((res) => {
            setEvents([...res.data]);
        })
    }, [])

    const handleAddEvent = (event) => {
        axios.post('http://localhost:8888/events', JSON.stringify({event}), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then((res) => {
            event.id = res.data.insertId;
            setEvents([...events, event]);
        })
    };

    const handleDeleteEvent = (id) => {

        axios.delete('http://localhost:8888/events/' + id,{
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then((res) => {
            const updatedEvents = events.filter((event) => event.id !== id);
            setEvents(updatedEvents);
        })
    };

    const handleEditEvent = (id, updatedEvent) => {
        axios.put('http://localhost:8888/events', JSON.stringify({updatedEvent}), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }).then((res) => {
            const updatedEvents = events.map((event) =>
                event.id === id ? updatedEvent : event
            );
            setEvents(updatedEvents);
        })
    };

    return (
        <div className="event-table-container">
            <EventForm onAddEvent={handleAddEvent}/>
            <table className="event-table">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Location</th>
                    <th>Edit/Delete</th>
                </tr>
                </thead>
                <tbody>
                {events.map((event) => (
                    <EventRow
                        key={event.id}
                        event={event}
                        onDeleteEvent={handleDeleteEvent}
                        onEditEvent={handleEditEvent}
                    />
                ))}
                </tbody>
            </table>
        </div>
    );
}

function EventRow({event, onDeleteEvent, onEditEvent}) {
    const [isEditing, setIsEditing] = useState(false);
    const [updatedEvent, setUpdatedEvent] = useState(event);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        onEditEvent(event.id, updatedEvent);
        setIsEditing(false);
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setUpdatedEvent(event);
    };

    const handleDeleteClick = () => {
        onDeleteEvent(event.id);
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setUpdatedEvent({...updatedEvent, [name]: value});
    };

    if (isEditing) {
        return (
            <tr>
                <td>{event.id}</td>
                <td>
                    <input
                        type="date"
                        name="date"
                        value={updatedEvent.date}
                        onChange={handleInputChange}
                    />
                </td>
                <td>
                    <input
                        type="time"
                        name="startTime"
                        value={updatedEvent.startTime}
                        onChange={handleInputChange}
                    />
                </td>
                <td>
                    <input
                        type="time"
                        name="endTime"
                        value={updatedEvent.endTime}
                        onChange={handleInputChange}
                    />
                </td>
                <td>
                    <select name="location" onChange={handleInputChange} value={updatedEvent.location} required>
                        <option value="Plazores">Plazores</option>
                        <option value="Corcela">Corcela</option>
                    </select>
                </td>
                <td>
                    <button onClick={handleSaveClick}>Save</button>
                    <button onClick={handleCancelClick}>Cancel</button>
                </td>
            </tr>
        );
    } else {
        return (
            <tr>
                <td>{event.id}</td>
                <td>{new Date(event.date).toLocaleDateString()}</td>
                <td>{event.startTime}</td>
                <td>{event.endTime}</td>
                <td>{event.location}</td>
                <td>
                    <button onClick={handleEditClick}>Edit</button>
                    <button onClick={handleDeleteClick}>Delete</button>
                </td>
            </tr>
        );
    }
}

function EventForm({onAddEvent}) {
    const [event, setEvent] = useState({
        date: "",
        startTime: "",
        endTime: "",
        location: "",
        link: "",
        id: -1,
    });

    const handleSubmit = (event) => {
        console.log(event.target[0].value)
        event.preventDefault();
        onAddEvent({
            date: event.target[0].value,
            startTime: event.target[1].value,
            endTime: event.target[2].value,
            location: event.target[3].value,
            id: -1,
        });
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setEvent({...event, [name]: value});
    };

    return (
        <form class="add-form" onSubmit={handleSubmit}>
            <label>Date</label>
            <input
                type="date"
                name="date"
                value={event.date}
                onChange={handleInputChange}
                required
            />
            <label>Start Time</label>
            <input
                type="time"
                name="startTime"
                value={event.startTime}
                onChange={handleInputChange}
                required
            />
            <label>End Time</label>
            <input
                type="time"
                name="endTime"
                value={event.endTime}
                onChange={handleInputChange}
                required
            />
            <label>Location</label>
            <select name="location" onChange={handleInputChange} required>
                <option value="Plazores">Plazores</option>
                <option value="Corcela">Corcela</option>
            </select>
            <button type="submit">Add Event</button>
        </form>
    );
}

export default EventTable;
